"use client";

import { EmblaCarouselType } from "embla-carousel";
import React, {
  ComponentPropsWithRef,
  useCallback,
  useEffect,
  useState,
} from "react";

type UsePrevNextButtonsType = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: (n: number) => void;
  onNextButtonClick: (n: number) => void;
};

export const usePrevNextButtons = (
  emblaApi: EmblaCarouselType | undefined,
): UsePrevNextButtonsType => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(
    (n: number) => {
      if (!emblaApi) return;

      emblaApi.scrollTo(emblaApi.selectedScrollSnap() - n);
    },
    [emblaApi],
  );

  const onNextButtonClick = useCallback(
    (n: number) => {
      if (!emblaApi) return;
      emblaApi.scrollTo(emblaApi.selectedScrollSnap() + n);
    },
    [emblaApi],
  );

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

type PropType = ComponentPropsWithRef<"button">;

const style =
  "bg-input hover:bg-primary disabled:bg-primary z-[1] m-0 flex h-[0.8rem] w-[0.8rem] cursor-pointer touch-manipulation appearance-none items-center justify-center rounded-full border-0 p-0 transition-all duration-200 ease-in-out";

export const PrevButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <button className={style} type="button" {...restProps}>
      {children}
    </button>
  );
};

export const NextButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <button className={style} type="button" {...restProps}>
      {children}
    </button>
  );
};
